import { getURLParameter } from "../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import PlayMode from "../../equalture/model/PlayMode";

export default class AppModel {

    constructor() {
        this._language = null;
    }


    set language(id) {
        this._language = id;
    }

    get language() {
        return AppModel.debugLanguage || this._language;
    }

    set playMode(playMode) {
        this._playMode = playMode;
    }

    /** @type {PlayMode|string} */
    get playMode() {
        return AppModel.debugPlayMode || this._playMode || PlayMode.ASSESSMENT;
    }
}

//Static stuff:

//Platforms
AppModel.isAndroid = /Android/i.test(navigator.userAgent);
AppModel.isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
AppModel.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
AppModel.isPhone = AppModel.isMobile;//TODO: somehow exclude tablets here
AppModel.isTouch = window.ontouchstart !== undefined || getURLParameter("touch") == "1";

//Debug stuff    
AppModel.debugPlayMode = getURLParameter("mode");
AppModel.debugLanguage = getURLParameter("lang");
if (getURLParameter("phone") != null) AppModel.isPhone = getURLParameter("phone") == "1";
if (getURLParameter("mobile") != null) AppModel.isMobile = getURLParameter("mobile") == "1";
AppModel.easterEggsEnabled = getURLParameter("easteregg") == "1";
